import { defineComponent as _defineComponent } from 'vue'
import TableWithActions2 from '@/components/tableWithActions/TableWithActions2.vue';
import { getCurrentInstance, onBeforeMount, ref } from 'vue';
import { useI18n } from '@/composables/i18n';
import { StandardAlert } from '@/models/standardAlert';
import {
  formatWithUnit,
  matchesDateGrouping,
  matchesMetric,
  matchesOperator,
  matchesStatus,
  matchesThreshold,
  translateKpi,
  translateOperator,
  translateStatus,
  translateVariable,
} from '@/utils/alerts';
import { translateDateGrouping } from '@/utils/dates';
import { listToCommaSeparatedString } from '@/utils/array';
import { isEmpty, isNil } from '@/utils/misc';
import { matchIgnoringCase } from '@/utils/table';
import { standardAlertsService } from '@/services/standardAlerts.service';
import TableActionButton2 from '@/components/tableWithActions/TableActionButton2.vue';
import { modalService } from '@/library-services/modal.service';
import StandardAlertDetailedView from './StandardAlertDetailedView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CareConsoleStandardAlerts',
  setup(__props) {

const standardAlerts = ref<StandardAlert[]>([]);
const isLoading = ref(false);

const app = getCurrentInstance();

onBeforeMount(async () => {
  standardAlerts.value = await fetchStandardAlerts();
});

async function fetchStandardAlerts(): Promise<StandardAlert[]> {
  isLoading.value = true;
  try {
    return await standardAlertsService.getAll();
  } finally {
    isLoading.value = false;
  }
}

// Keep this code synced with its column
function matchesAdditionalInformation(
  standardAlert: StandardAlert,
  searchText: string,
): boolean {
  const additionalInformationText =
    t('e_service_center.standard_alerts.event_sources', {
      eventSources: listToCommaSeparatedString(standardAlert.eventSources),
    }).toString() +
    t('e_service_center.standard_alerts.event_codes', {
      eventCodes: listToCommaSeparatedString(standardAlert.eventCodes),
    }).toString() +
    t('e_service_center.standard_alerts.variable', {
      variable: translateVariable(standardAlert.variable, standardAlert.metric),
    }).toString();
  return matchIgnoringCase(additionalInformationText, searchText);
}

function openDetails(standardAlert: StandardAlert) {
  modalService.compositionApi.open(
    {
      component: StandardAlertDetailedView,
      width: '800px',
      props: {
        standardAlert,
      },
    },
    app,
  );
}

const { t } = useI18n();

return { __sfc: true,standardAlerts, isLoading, app, fetchStandardAlerts, matchesAdditionalInformation, openDetails, t, TableWithActions2, formatWithUnit, matchesDateGrouping, matchesMetric, matchesOperator, matchesStatus, matchesThreshold, translateKpi, translateOperator, translateStatus, translateVariable, translateDateGrouping, listToCommaSeparatedString, isEmpty, isNil, TableActionButton2 }
}

})